import { combineReducers } from 'redux';

import isInsertingRequesterCheckField from './isInsertingRequesterCheckField';
import isInsertingRequesterImageField from './isInsertingRequesterImageField';
import isInsertingRequesterTextField from './isInsertingRequesterTextField';
import keywords from './keywords';
import lastRequesterCheckField from './lastRequesterCheckField';
import lastRequesterImageField from './lastRequesterImageField';
import lastRequesterTextField from './lastRequesterTextField';
import requesterAttachments from './requesterAttachments';
import requesterCheckFields from './requesterCheckFields';
import requesterImageFields from './requesterImageFields';
import requesterInputIdsInPage from './requesterInputIdsInPage';
import requesterTextFields from './requesterTextFields';
import requestMethod from './requestMethod';

export default combineReducers({
  isInsertingRequesterCheckField,
  isInsertingRequesterImageField,
  isInsertingRequesterTextField,
  lastRequesterCheckField,
  lastRequesterImageField,
  lastRequesterTextField,
  keywords,
  requesterAttachments,
  requesterCheckFields,
  requesterImageFields,
  requesterTextFields,
  requesterInputIdsInPage,
  requestMethod,
});
